// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== ERROR STATE ==================== */

.locationpage-error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.locationpage-error-content {
  background: white;
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 500px;
}

.locationpage-error-content h2 {
  color: #f43f5e;
  margin: 0 0 16px 0;
  font-size: 24px;
}

.locationpage-error-content p {
  color: #666;
  margin: 0 0 24px 0;
  line-height: 1.6;
}

.locationpage-error-btn {
  padding: 10px 24px;
  background: #007BFF;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.3s ease;
}

.locationpage-error-btn:hover {
  background: #0056b3;
}

/* ==================== LOADING STATE ==================== */

.locationpage-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  gap: 20px;
}

.locationpage-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.locationpage-loading-container p {
  color: white;
  font-size: 16px;
}

/* ==================== HEADER IMPROVEMENTS ==================== */

.locationpage-title-block {
  flex: 1 1;
}

.locationpage-year {
  font-size: 14px;
  color: #888;
  margin: 4px 0 0 0;
}

.locationpage-fetch-mode {
  font-size: 12px;
  color: #aaa;
  margin: 4px 0 0 0;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/LocationPage/LocationPage.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;EAC7D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,kEAAkE;;AAElE;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* ==================== ERROR STATE ==================== */\n\n.locationpage-error-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.locationpage-error-content {\n  background: white;\n  padding: 40px;\n  border-radius: 16px;\n  text-align: center;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 500px;\n}\n\n.locationpage-error-content h2 {\n  color: #f43f5e;\n  margin: 0 0 16px 0;\n  font-size: 24px;\n}\n\n.locationpage-error-content p {\n  color: #666;\n  margin: 0 0 24px 0;\n  line-height: 1.6;\n}\n\n.locationpage-error-btn {\n  padding: 10px 24px;\n  background: #007BFF;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: background 0.3s ease;\n}\n\n.locationpage-error-btn:hover {\n  background: #0056b3;\n}\n\n/* ==================== LOADING STATE ==================== */\n\n.locationpage-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  gap: 20px;\n}\n\n.locationpage-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.locationpage-loading-container p {\n  color: white;\n  font-size: 16px;\n}\n\n/* ==================== HEADER IMPROVEMENTS ==================== */\n\n.locationpage-title-block {\n  flex: 1;\n}\n\n.locationpage-year {\n  font-size: 14px;\n  color: #888;\n  margin: 4px 0 0 0;\n}\n\n.locationpage-fetch-mode {\n  font-size: 12px;\n  color: #aaa;\n  margin: 4px 0 0 0;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
